class Urls {

  publicApi() {
    let api = localStorage.getItem("UseLocalAPi");
    api = JSON.parse(api);
    if (api) return window.config.urls.baseUrlDebug;
    return window.config.urls.baseUrl;
  }

  publicCoreApi() {
    return window.config.urls.coreApi;
  }

  grantType() {
    return window.config.grantType;
  }
  login() {
    return `${this.publicApi()}/crm-token`;
  }
  searchWithCriterial() {
    return `${this.publicApi()}/api/CrmCustomer/GetCustomersByCriterias`;
  }
  getSearchedUserById(id) {
    return `${this.publicApi()}/api/CrmCustomer/GetCustomerProfileInformationById?Id=${id}`;
  }
  getSearchedUserInvoiceHistoryById(id) {
    return `${this.publicApi()}/api/CrmCustomer/GetCustomerInvoiceHistory?CustomerId=${id}`;
  }
  getSearchedUserPackagesById(id) {
    return `${this.publicApi()}/api/CrmCustomer/GetCustomerPackages?CustomerId=${id}`;
  }
  getSearchedUserLinesById(id) {
    return `${this.publicApi()}/api/CrmCustomer/GetCustomerLines?CustomerId=${id}`;
  }
  getSearchedUserLinesAuthDataById(id) {
    return `${this.publicApi()}/api/CrmVerification/GetCustomerNidFullInfo?CustomerId=${id}`;
  }
  inquireNid() {
    return `${this.publicApi()}/api/CrmVerification/InquireNid`;
  }
  acceptInquireNid(id) {
    return `${this.publicApi()}/api/CrmVerification/AcceptNid?FinnotechNidInquiryId=${id}`;
  }
  rejectInquireNid(id, reasonCode, reason) {
    return `${this.publicApi()}/api/CrmVerification/RejectNid?FinnotechNidInquiryId=${id}&reasonCode=${reasonCode}&reasonText=${reason}`;
  }
  rejectInquireNidByCustomerId(id, reasonCode, reason) {
    return `${this.publicApi()}/api/CrmVerification/RejectNidByCustomerId?customerId=${id}&reasonCode=${reasonCode}&reasonText=${reason}`;
  }
  activateLines(id) {
    return `${this.publicApi()}/api/CrmLine/SetCustomerLineAsManuallyConfirmed?customerLineId=${id}`;
  }
  rejectActivationLines(id, reason) {
    return `${this.publicApi()}/api/CrmLine/SetCustomerLineStatusAsRejectActivation?customerLineId=${id}&reason=${reason}`;
  }
  loginAsUser(id) {
    return `${this.publicApi()}/api/OaaLogin/GetUrlToLogin?customerId=${id}`;
  }
  getNotConfirmedLinesList() {
    return `${this.publicApi()}/api/CrmLine/GetNotConfirmedCustomerLines`;
  }
  getUserNotes(id) {
    return `${this.publicApi()}/api/CrmUserNotes/GetAllNotes?customerId=${id}`;
  }
  setUserNotes(id) {
    return `${this.publicApi()}/api/CrmUserNotes/SaveNote?customerId=${id}`;
  }
  sendSms() {
    return `${this.publicApi()}/api/CrmCustomer/SendSmsByCustomerId`;
  }
  getRejectedConfirmationCustomerLines() {
    return `${this.publicApi()}/api/CrmLine/GetRejectedConfirmationCustomerLines`;
  }
  getCustomerCredit(id) {
    return `${this.publicApi()}/api/CrmCustomer/GetCustomerCredit?customerId=${id}`;
  }
  extendCustomerIvrPackage(id, extendedDays) {
    return `${this.publicApi()}/api/CrmCustomerProductUserAction/ExtendCustomerIvrPackage?customerId=${id}&extendedDays=${extendedDays}`;
  }
  extendCustomerSecretaryPackage(id, extendedDays) {
    return `${this.publicApi()}/api/CrmCustomerProductUserAction/ExtendCustomerSecretaryPackage?customerId=${id}&extendedDays=${extendedDays}`;
  }
  extendCustomerFaxPackage(id, extendedDays) {
    return `${this.publicApi()}/api/CrmCustomerProductUserAction/ExtendCustomerFaxPackage?customerId=${id}&extendedDays=${extendedDays}`;
  }
  cancelCustomerFreeIvrPackage(id, extendedDays) {
    return `${this.publicCoreApi()}/api/CrmCustomerProductUserAction/CancelCustomerFreeIvrPackage?customerId=${id}`;
  }
  cancelCustomerFreeSecretaryPackage(id, extendedDays) {
    return `${this.publicCoreApi()}/api/CrmCustomerProductUserAction/CancelCustomerFreeSecretaryPackage?customerId=${id}`;
  }
  reTestFreeIvrPackage(id, extendedDays) {
    return `${this.publicApi()}/api/CrmCustomerProductUserAction/ReTestFreeIvrPackage?customerId=${id}`;
  }
  reTestFreeSecretaryPackage(id, extendedDays) {
    return `${this.publicApi()}/api/CrmCustomerProductUserAction/ReTestFreeSecretaryPackage?customerId=${id}`;
  }
  getProvinceWithCity() {
    return `${this.publicApi()}/api/profile/GetAllProvincesWithCities`;
  }
  getCustomerEmailHistory(objModel) {
    return `${this.publicApi()}/api/EmailVerification/CustomerEmailHistory`;
  }
  saveByAdmin(objModel) {
    return `${this.publicApi()}/api/profile/SaveByAdmin`;
  }

  ResendInvoice(InvoiceId) {
    return `${this.publicCoreApi()}/api/MoadianOffcialFactor/SendOffcialFactor/${InvoiceId}`;
  }

  GetNewStatusForAllPendingRequest() {
    return `${this.publicCoreApi()}/api/MoadianOffcialFactor/getNewStatusForAllPendingRequest`;
  }

  UpdateReservedFactorForMoadian() {
    return `${this.publicApi()}/api/Transaction/UpdateReservedFactorForMoadian`;
  }

  // GetReservedFactorForMoadian() {
  //   return `${this.publicApi()}/api/Transaction/GetOfficialFactorLists`;
  // }

  GetMoadianLog() {
    return `${this.publicApi()}/api/Transaction/GetMoadianLog`;
  }

  GetAllInvoiceNumber() {
    return `${this.publicApi()}/api/Transaction/GetAllInvoiceNumber`;
  }
  insertInvoice() {
    return `${this.publicApi()}/api/Transaction/InsertNewOfficialFactors`;
  }
  getOfficialFactorLists() {
    return `${this.publicApi()}/api/Transaction/GetOfficialFactorLists`;

  }
  getReturnedOrRevokedFactors() {
    return `${this.publicApi()}/api/Transaction/GetReturnedOrRevokedFactors`;

  }

  changeFactorTypeToRevokeOrReturn() {
    return `${this.publicApi()}/api/Transaction/ChangeFactorTypeToRevokeOrReturnedFromSale`;
  }

  UpdateOfficialFactors() {
    return `${this.publicApi()}/api/Transaction/UpdateOfficialFactors`;

  }
  GetFinancialPeriods() {
    return `${this.publicApi()}/api/Transaction/GetFinancialPeriods`;
  }

  unLockeMobile(id) {
    return `${this.publicApi()}/api/CrmCustomer/UnlockMobile?CustomerId=${id} `;
  }

  unLockeEmail(id) {
    return `${this.publicApi()}/api/profile/UnlockEmail`;
  }
  GetAllService() {
    return `${this.publicApi()}/api/Transaction/ServiceSepidar`;
  }
  PostCustomer() {
    return `${this.publicApi()}/api/Transaction/CustomerSepidar`;
  }
  PostInvoice() {
    return `${this.publicApi()}/api/Transaction/FactorSepidar`;
  }
  GetHistoryOfImportantEntities() {
    return `${this.publicCoreApi()}/api/EventHistory/GetHistoryOfImportantEntities`;
  }
  GetEntitiesEnum() {
    return `${this.publicCoreApi()}/api/EventHistory/GetEntitiesEnum`;
  }
  GetAdminUsers() {
    return `${this.publicCoreApi()}/api/EventHistory/GetAdminUsers`;
  }
  GetRequestLogOfImportantAPIs() {
    return `${this.publicCoreApi()}/api/RequestLog/GetRequestLogOfImportantAPIs`;
  }



  getDiscountCodes(obj) {
    return `${this.publicCoreApi()}/api/CrmDiscountCode/GetDiscountCodes`;
  }
  getDiscountServices(type) {
    return `${this.publicCoreApi()}/api/CrmDiscountCode/GetServiceProducts?productType=${type}`;
  }
  createCoupons() {
    return `${this.publicCoreApi()}/api/CrmDiscountCode/CreateNewDiscountCode`;
  }
  couponDetails(id) {
    return `${this.publicCoreApi()}/api/CrmDiscountCode/GetDiscountCodeDetails?Id=${id}`;
  }
  enableCoupon(id) {
    return `${this.publicCoreApi()}/api/CrmDiscountCode/ManuallyMakeDiscountCodeUsable?Id=${id}`;
  }
  disableCoupon(id) {
    return `${this.publicCoreApi()}/api/CrmDiscountCode/ManuallyMakeDiscountCodeUnusable?Id=${id}`;
  }
  extendCoupon(id, date) {
    return `${this.publicCoreApi()}/api/CrmDiscountCode/ExtendDiscountCode?Id=${id}&endDatePersianStr=${date}`;
  }
  addHolidays() {
    return `${this.publicCoreApi()}/api/PersianHoliday/Insert`;

  }
  getHolidays() {
    return `${this.publicCoreApi()}/api/PersianHoliday/GetAll`;

  }
  updateHolidays() {
    return `${this.publicCoreApi()}/api/PersianHoliday/Update`;

  }
  deleteHolidays() {
    return `${this.publicCoreApi()}/api/PersianHoliday/Delete`;

  }
  GetActiveProducts() {
    return `${this.publicCoreApi()}/api/Product/GetActiveProducts`;

  }

  GetRestrictedCall() {
    return `${this.publicCoreApi()}/api/RestrictedCall/AdminPanelRestrectedCallReport`;

  }

  ChangeLineStatus() {
    return `${this.publicCoreApi()}/api/RestrictedCall/ChangeLineStatus`;

  }




  EditProductPrice() {
    return `${this.publicCoreApi()}/api/Product/CloneProductFromProductId`;

  }

}
export default new Urls();
